var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7548 18.394L16.1277 14.7669C17.0009 13.6043 17.4723 12.1893 17.4707 10.7354C17.4707 7.02151 14.4492 4 10.7354 4C7.02151 4 4 7.02151 4 10.7354C4 14.4492 7.02151 17.4707 10.7354 17.4707C12.1893 17.4723 13.6043 17.0009 14.7669 16.1277L18.394 19.7548C18.5776 19.9189 18.8171 20.0065 19.0632 19.9996C19.3094 19.9927 19.5436 19.8919 19.7177 19.7177C19.8919 19.5436 19.9927 19.3094 19.9996 19.0632C20.0065 18.8171 19.9189 18.5776 19.7548 18.394ZM5.92439 10.7354C5.92439 9.78384 6.20655 8.85369 6.73518 8.06253C7.26382 7.27137 8.01519 6.65473 8.89428 6.2906C9.77337 5.92647 10.7407 5.8312 11.6739 6.01683C12.6072 6.20246 13.4644 6.66066 14.1372 7.33349C14.8101 8.00632 15.2683 8.86355 15.4539 9.79679C15.6395 10.73 15.5442 11.6973 15.1801 12.5764C14.816 13.4555 14.1994 14.2069 13.4082 14.7355C12.617 15.2642 11.6869 15.5463 10.7354 15.5463C9.45988 15.5448 8.23708 15.0374 7.33518 14.1355C6.43328 13.2336 5.92592 12.0108 5.92439 10.7354Z",
    fill: "#020819",
    stroke: "#020819",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3f7a978ceab02a73d1dda8f4b5242c2e.svg";
export { ForwardRef as ReactComponent };